<template>
  <section id="dashboard-ecommerce"><br>
	<b-modal
		id="affsuppplan"
		ref="my-modal"
		title="Validation"
		button-size="sm"
		centered
		no-fade
		ok-only
		ok-title="Fermer"
    >
      <div class="d-block text-center" />
		<b-button
			variant="outline-primary"
			@click="delplan()"
		>
		Oui supprimer le plan
		</b-button>
    </b-modal>
    <b-row >
    	<b-col 
			cols="7"
		>
    	<home-medal :resultSoc='ResultSoc' /><br>	
		  <b-card>
			<vue-good-table
				:columns="columns"
				:rows="rows"
				:pagination-options="{
					enabled: true,
					mode: 'records',
					perPage: 15,
					position: 'top',
					perPageDropdown: [5, 10, 15,  20],
					dropdownAllowAll: false,
					jumpFirstOrLast : true,
					firstLabel : 'Première Page',
					lastLabel : 'Dernière Page',
					nextLabel: 'Suivant',
					prevLabel: 'Précédent',
					rowsPerPageLabel: 'ligne par page',
					ofLabel: 'de',
					pageLabel: 'page', // for 'pages' mode
					allLabel: 'Tout',
					infoFn: (params) => `my own page ${params.firstRecordOnPage}`, 
					}"
				:search-options="{
					enabled: true,
					placeholder: 'Recherche',
					}"
				@on-row-click="onRowClick"
			>
			  <template
				slot="table-row"
				slot-scope="props"
			  >
				<span
				  v-if="props.column.field === 'C_libelle'"
				  class="text-nowrap"
				>
				  <b-avatar
					:src="props.row.C_logop"
					class="mx-1"
				  />
				  <span>{{ props.row.C_libelle }}</span>
				</span>
				<span v-else>
				  {{ props.formattedRow[props.column.field] }}
				</span>
			  </template>
			</vue-good-table>
		</b-card>
      </b-col>
      <b-col>
		  <b-card
			no-body
			v-if="CUI !== ''"
			class="card-developer-meetup"
		  >
			<div class="bg-light-primary rounded-top text-center">
			  <b-img
				:src="selctrow.C_logo"
				fluid
			  />
			</div>
			<b-card-body>
			<!-- metting header -->
			<div class="meetup-header d-flex align-items-center">
			<div class="meetup-day">
			  <h6 class="mb-0">
				BX
			  </h6>
			  <h3 class="mb-0">
				2022
			  </h3>
			</div>
			<div class="my-auto">
			  <b-card-title class="mb-25">
				{{selctrow.C_libelle}}
			  </b-card-title>
			  <b-card-text class="mb-0">
				{{selctrow.C_adresse}}
			  </b-card-text>
			  <b-card-text class="mb-0">
				{{CUI}}
			  </b-card-text>
			</div>
			</div>
			<!--/ metting header -->

			<!-- media -->
			<b-media
			v-for="media in mediaData"
			:key="media.avatar"
			no-body
			>
			<b-media-aside class="mr-1">
			  <b-avatar
				rounded
				variant="light-primary"
				size="34"
			  >
				<feather-icon
				  :icon="media.avatar"
				  size="18"
				/>
			  </b-avatar>
			</b-media-aside>
			<b-media-body>
			  <h6 class="mb-0">
				{{ media.title }}
			  </h6>
			  <small>{{ media.subtitle }}</small>
			</b-media-body>
			</b-media>

			<!-- avatar group -->
			<b-avatar-group
			class="mt-2 pt-50"
			size="33"
			>
			<b-avatar
			  v-for="avatar in avatars"
			  :key="avatar.avatar"
			  v-b-tooltip.hover.bottom="avatar.fullName"
			  :src="avatar.avatar"
			  class="pull-up"
			/>
			</b-avatar-group>
			<hr>
			<h5 class="align-self-center cursor-pointer ml-1 mb-0">Mise en production</h5>
			<div class="demo-inline-spacing">
				<b-form-checkbox
					v-model="bcentreenprod"
					value="1"
					plain
				>
					Centre en production
			  	</b-form-checkbox>
				<b-form-checkbox
					v-model="bemplacement"
					value="1"
					plain
				>
					Emplacements validés
				</b-form-checkbox>
				<b-form-checkbox
					v-model="bbox"
					value="1"
					plain
				>
					boxes validés
				</b-form-checkbox>
				<b-form-checkbox
					v-model="bplan"
					value="1"
					plain
				>
					Plans validés
				</b-form-checkbox>
				<b-form-checkbox
					v-model="bmodelecontrat"
					value="1"
					plain
				>
					Contrats validés
				</b-form-checkbox>
				<br>
				<b-button
					v-ripple.400="'rgba(255, 255, 255, 0.15)'"
					variant="primary"
					@click="majinitsoc()"
				>
				  Valider
				</b-button>
			</div>
			<br>
			<hr>
			<h5 class="align-self-center cursor-pointer ml-1 mb-0">Informations générale</h5>
			<div class="demo-inline-spacing">
				<b-form-checkbox
				v-model="bnationalbox"
				value="1"
				plain
			  >
				Centre National Box
			  </b-form-checkbox>
			</div>
			<br>
			<b-button
				v-ripple.400="'rgba(255, 255, 255, 0.15)'"
				variant="primary"
				@click="majsparamsoc()"
			>
			  Valider
			</b-button>
			<hr>
			<h5 class="align-self-center cursor-pointer ml-1 mb-0">Fonction signatures électroniques</h5>
			<div class="demo-inline-spacing">
				<b-form-radio
				v-model="bsignatureactive"
				plain
				name="rbsignatureactive"
				value="1"
				>
				Active
				</b-form-radio>
				<b-form-radio
				v-model="bsignatureactive"
				plain
				name="rbsignatureactive"
				value="0"
				>
				Inactive
				</b-form-radio>
			</div>
			<div class="demo-inline-spacing"  v-if="bsignatureactive">
				<b-form-radio
				v-model="bsignaturmarquage"
				plain
				name="rbsignaturmarquage"
				value="1"
				>
				Marquage activé (Bande sur la gauche)
				</b-form-radio>
				<b-form-radio
				v-model="bsignaturmarquage"
				plain
				name="rbsignaturmarquage"
				value="0"
				>
				Marquage déactivé
				</b-form-radio>
			</div>
			<div class="demo-inline-spacing" v-if="bsignatureactive">
				<b-form-radio
				v-model="bsignatureprod"
				plain
				name="rbsignatureprod"
				value="1"
				>
				En production
				</b-form-radio>
				<b-form-radio
				v-model="bsignatureprod"
				plain
				name="rbsignatureprod"
				value="0"
				>
				En test
				</b-form-radio>
			</div>
			<b-form-group
				label="Nb signatures par mois"
				label-for="nbsign"
				v-if="bsignatureactive"
			>
			  <b-form-input
				v-model="nbsign"
				id="nbsign"
			  />
			</b-form-group>
			<b-button
				v-ripple.400="'rgba(255, 255, 255, 0.15)'"
				variant="primary"
				@click="majsign()"
			>
			  Valider
			</b-button>
			<hr>
			<h5 class="align-self-center cursor-pointer ml-1 mb-0">Chat support des clients finaux (Chatwoot)</h5>
			<p class="text-muted mt-1 mb-1">
				Active le chat permettant au gestionnaire du centre de répondre à ses clients finaux
				depuis Chatwoot. Provisioning automatique : crée un compte Chatwoot dédié au centre,
				une inbox Website et active la validation d'identité (HMAC). Le widget apparaît ensuite
				dans l'espace client et le plugin WordPress du centre, au prochain refresh de session
				du client final.
			</p>
			<div v-if="chatwoot.loading" class="demo-inline-spacing">
				<b-spinner small variant="primary" /> Chargement…
			</div>
			<div v-else-if="chatwoot.configured" class="demo-inline-spacing">
				<b-badge variant="light-success">
					Activé · inbox <code>{{ chatwoot.inbox_id }}</code>
				</b-badge>
				<b-button
					v-ripple.400="'rgba(255, 255, 255, 0.15)'"
					variant="outline-secondary"
					:href="chatwoot.base_url"
					target="_blank"
					rel="noopener"
				>
					Ouvrir Chatwoot
				</b-button>
				<b-button
					v-ripple.400="'rgba(255, 255, 255, 0.15)'"
					variant="outline-secondary"
					:disabled="chatwoot.busy"
					@click="applyDefaultFeatures()"
					title="Re-désactive les features Enterprise + V2 (Captain, Audit, SLA, Help Center, Automations…) si elles ont réapparu après mise à jour Chatwoot."
				>
					<b-spinner v-if="chatwoot.busy" small /> Réappliquer features par défaut
				</b-button>
				<b-button
					v-ripple.400="'rgba(255, 255, 255, 0.15)'"
					variant="outline-danger"
					:disabled="chatwoot.busy"
					@click="deprovisionChatwoot()"
				>
					<b-spinner v-if="chatwoot.busy" small /> Désactiver côté BUXIDA
				</b-button>
			</div>
			<div v-else class="demo-inline-spacing">
				<b-badge variant="light-secondary">Non activé</b-badge>
				<b-button
					v-ripple.400="'rgba(255, 255, 255, 0.15)'"
					variant="success"
					:disabled="chatwoot.busy"
					@click="provisionChatwoot()"
				>
					<b-spinner v-if="chatwoot.busy" small />
					{{ chatwoot.busy ? 'Provisioning…' : 'Activer le chat support clients finaux' }}
				</b-button>
			</div>
			<hr>
			<h5 class="align-self-center cursor-pointer ml-1 mb-0">Site web du centre (WP Multisite)</h5>
			<p class="text-muted mt-1 mb-1">
				Provisionne un site WordPress dédié pour ce centre sur <code>*.self-stockage.solutions</code>.
				Le site est créé en mode "Coming Soon", le gestionnaire le personnalise puis vous validez la mise en ligne.
			</p>
			<div v-if="wpSubsite.loading" class="demo-inline-spacing">
				<b-spinner small variant="primary" /> Chargement…
			</div>
			<div v-else-if="!wpSubsite.configured" class="mt-2">
				<b-row>
					<b-col md="6">
						<b-form-group label="Slug du sous-domaine" label-for="wp-slug">
							<b-input-group :append="`.self-stockage.solutions`">
								<b-form-input
									id="wp-slug"
									v-model="wpSubsite.slugInput"
									placeholder="monboxlyon"
									:disabled="wpSubsite.busy"
									@blur="checkWpSlug()"
								/>
							</b-input-group>
							<small v-if="wpSubsite.slugCheckBusy" class="text-muted">Vérification…</small>
							<small v-else-if="wpSubsite.slugAvailable === true" class="text-success">✓ Slug disponible</small>
							<small v-else-if="wpSubsite.slugAvailable === false" class="text-danger">✗ Slug indisponible ou invalide</small>
							<small v-else class="text-muted">3-60 caractères, alphanumériques + tirets, sans tiret en début/fin</small>
						</b-form-group>
					</b-col>
					<b-col md="6">
						<b-form-group label="Email du gestionnaire (admin WP)" label-for="wp-email">
							<b-form-input
								id="wp-email"
								v-model="wpSubsite.adminEmailInput"
								type="email"
								placeholder="(par défaut : email du centre)"
								:disabled="wpSubsite.busy"
							/>
							<small class="text-muted">Si vide, l'email du centre (TB_SOCIETE.C_email) sera utilisé.</small>
						</b-form-group>
					</b-col>
				</b-row>
				<b-button
					v-ripple.400="'rgba(255, 255, 255, 0.15)'"
					variant="success"
					:disabled="wpSubsite.busy || !wpSubsite.slugInput"
					@click="provisionWpSubsite()"
				>
					<b-spinner v-if="wpSubsite.busy" small />
					{{ wpSubsite.busy ? 'Création en cours…' : 'Créer le site web' }}
				</b-button>
			</div>
			<div v-else class="mt-2">
				<div class="mb-2">
					<b-badge :variant="wpSubsite.status === 'published' ? 'light-success' : (wpSubsite.status === 'pending_review' ? 'light-info' : 'light-warning')">
						{{ wpSubsite.status === 'published' ? 'Publié' : (wpSubsite.status === 'pending_review' ? 'En attente de validation' : 'En construction') }}
					</b-badge>
					&nbsp;
					<a :href="wpSubsite.url" target="_blank" rel="noopener"><code>{{ wpSubsite.url }}</code></a>
				</div>
				<div class="text-muted small mb-2">
					Slug : <code>{{ wpSubsite.slug }}</code> ·
					Admin : <code>{{ wpSubsite.adminEmail }}</code> ·
					Blog ID : <code>{{ wpSubsite.blogId }}</code>
				</div>
				<div v-if="wpSubsite.publishRequestNote" class="alert alert-info py-1 px-2 mb-2 small">
					<strong>Note du gestionnaire :</strong> {{ wpSubsite.publishRequestNote }}
				</div>
				<div v-if="wpSubsite.reviewNote && wpSubsite.status !== 'published'" class="alert alert-warning py-1 px-2 mb-2 small">
					<strong>Vos dernières corrections demandées :</strong> {{ wpSubsite.reviewNote }}
				</div>
				<div class="demo-inline-spacing">
					<b-button
						v-ripple.400="'rgba(255, 255, 255, 0.15)'"
						variant="outline-secondary"
						:href="wpSubsite.url + 'wp-admin/'"
						target="_blank"
						rel="noopener"
					>
						Ouvrir WP-Admin
					</b-button>
					<b-button
						v-if="wpSubsite.status === 'pending_review'"
						v-ripple.400="'rgba(255, 255, 255, 0.15)'"
						variant="success"
						:disabled="wpSubsite.busy"
						@click="publishWpSubsite()"
					>
						<b-spinner v-if="wpSubsite.busy" small /> Valider et publier
					</b-button>
					<b-button
						v-if="wpSubsite.status === 'coming_soon' && wpSubsite.publishRequestedAt === null"
						v-ripple.400="'rgba(255, 255, 255, 0.15)'"
						variant="success"
						:disabled="wpSubsite.busy"
						@click="publishWpSubsite()"
					>
						<b-spinner v-if="wpSubsite.busy" small /> Publier maintenant (sans attendre demande gestionnaire)
					</b-button>
				</div>
				<div v-if="wpSubsite.status === 'pending_review'" class="mt-3">
					<b-form-group label="Demander des corrections au gestionnaire" label-for="wp-review-note">
						<b-form-textarea
							id="wp-review-note"
							v-model="wpSubsite.reviewNoteInput"
							rows="2"
							placeholder="Ex : ajouter les horaires d'ouverture sur la page contact, remplacer la photo d'accueil…"
							:disabled="wpSubsite.busy"
						/>
					</b-form-group>
					<b-button
						v-ripple.400="'rgba(255, 255, 255, 0.15)'"
						variant="outline-warning"
						:disabled="wpSubsite.busy"
						@click="requestChangesWpSubsite()"
					>
						<b-spinner v-if="wpSubsite.busy" small /> Renvoyer pour corrections
					</b-button>
				</div>
			</div>
			<hr>
			<h5 class="align-self-center cursor-pointer ml-1 mb-0">Paramètres SMS</h5>
			<p class="text-muted mt-1 mb-1">
				Active l'envoi de SMS pour ce centre. Le quota mensuel limite le nombre de SMS envoyés par mois.
				Le sender (nom de l'expéditeur, 11 caractères max — alphanumérique) est enregistré
				automatiquement chez SMSAPI à la première utilisation.
			</p>
			<div v-if="sms.loading" class="demo-inline-spacing">
				<b-spinner small variant="primary" /> Chargement…
			</div>
			<div v-else>
				<b-row>
					<b-col md="6">
						<b-form-group label="Sender (nom expéditeur, 11 car. max)" label-for="sms-sender">
							<b-form-input
								id="sms-sender"
								v-model="sms.libelle"
								maxlength="11"
								placeholder="BUXIDA"
								:disabled="sms.busy"
							/>
							<small class="text-muted">Alphanumérique uniquement. Vide = "BUXIDA" par défaut.</small>
						</b-form-group>
					</b-col>
					<b-col md="6">
						<b-form-group label="Quota SMS / mois" label-for="sms-max">
							<b-form-input
								id="sms-max"
								v-model.number="sms.maxmois"
								type="number"
								min="0"
								:disabled="sms.busy"
							/>
							<small class="text-muted">0 = envoi désactivé.</small>
						</b-form-group>
					</b-col>
				</b-row>
				<div class="mb-2">
					<b-badge v-if="sms.configured && sms.maxmois > 0" variant="light-success">
						Activé · {{ sms.nbuse }} / {{ sms.maxmois }} ce mois (reste {{ sms.nbrest }})
					</b-badge>
					<b-badge v-else-if="sms.configured" variant="light-warning">
						Configuré mais désactivé (quota 0)
					</b-badge>
					<b-badge v-else variant="light-secondary">Non configuré</b-badge>
				</div>
				<b-button
					v-ripple.400="'rgba(255, 255, 255, 0.15)'"
					variant="primary"
					:disabled="sms.busy"
					@click="saveSmsParams()"
				>
					<b-spinner v-if="sms.busy" small /> Valider
				</b-button>
			</div>
			<hr>
			<h5 class="align-self-center cursor-pointer ml-1 mb-0">Plans</h5><br>
			<b-row>
				<b-col>
					<b-form-group
						label="Libelle du plan"
						label-for="libelleplan"
					>
					  <b-form-input
						v-model="libplan"
						id="libelleplan"
					  />
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group
						label="Liste des sites"
						label-for="soc"		
					 >
						<b-form-select
						id="soc"
						v-model = "idsite"
						:options="resultSite"
						/>
					</b-form-group>
				</b-col>
			</b-row>	
			<br>
			<b-button
				v-ripple.400="'rgba(255, 255, 255, 0.15)'"
				variant="primary"
				@click="addplan()"
			>
			  Ajouter un plan
			</b-button>
			<br><br>
			<span class="text-caption">Les plans affichés dans le navigateur sont decompressés : il faut donc bien les enregistrer de nouveau au format svgz</span><br><br>
			<vue-good-table
				:columns="columnsplan"
				:rows="rowsplan"
				:select-options="{ 
				enabled: true,
				selectOnCheckboxOnly: true, 
				selectionText: 'plan(s) sélectionné(s)',
				clearSelectionText: 'annuler'
				}"
				:sort-options="{
				enabled: true,
				}"
				@on-selected-rows-change="selectionPlanChanged"
			>
				<div slot="selected-row-actions"
				>
					<div  v-show="rowPlanSelection.length === 1"
					>
						<br>
						<b-button
							v-ripple.400="'rgba(255, 255, 255, 0.15)'"
							variant="primary"
							@click="dialdelplan(rowPlanSelection[0].C_UI)"
						>
						  Supprimer le plan
						</b-button>
						<br>
						<hr>
						<b-form-file
							v-model="file1"
							accept=".svgz"
							:state="Boolean(file1)"
							placeholder="Choisissez un fichier ou déposez-le ici.."
							drop-placeholder="Déposez le fichier ici..."
						></b-form-file>
						<div class="mt-3" v-if="file1">Plan : {{rowPlanSelection[0].C_UI}}</div>
						<button class="btn btn-success" v-if="file1" @click="upload(rowPlanSelection[0].C_UI)">
						  Upload
						</button>
						<div v-if="file1" class="progress">
							<div
							class="progress-bar progress-bar-info progress-bar-striped"
							role="progressbar"
							:aria-valuenow="progress"
							aria-valuemin="0"
							aria-valuemax="100"
							:style="{ width: progress + '%' }"
							>
							{{ progress }}%
							</div>
						</div>
					</div>
				</div>
				<template
				slot="table-row"
				slot-scope="props"
				>
				<span
				  v-if="props.column.field === 'C_libelle'"
				  class="text-nowrap"
				>
					<b-button
						v-ripple.400="'rgba(113, 102, 240, 0.15)'"
						variant="outline-primary"
						size="sm"
						@click="voirplan(props.row.C_UI)"
					>
					Voir
					</b-button>
					<span> {{ props.row.C_libelle }}</span>
				</span>
				<span v-else>
				  {{ props.formattedRow[props.column.field] }}
				</span>
				</template>
			</vue-good-table>
			<hr>
			<h5 class="align-self-center cursor-pointer ml-1 mb-0">Sites</h5><br>
			<b-row>
				<b-col>
					<b-form-group
						label="Libelle du site"
						label-for="libellesite"
					>
					  <b-form-input
						v-model="libsite"
						id="libellesite"
					  />
					</b-form-group>
				</b-col>
			</b-row>	
			<b-button
				v-ripple.400="'rgba(255, 255, 255, 0.15)'"
				variant="primary"
				@click="addsite()"
			>
			  Ajouter un site
			</b-button>
			<br><br>
			<vue-good-table
				:columns="columnsite"
				:rows="rowsite"
			>
				<div slot="selected-row-actions"
				>
					<div  v-show="rowPlanSelection.length === 1"
					>
						<br>
						<b-button
							v-ripple.400="'rgba(255, 255, 255, 0.15)'"
							variant="primary"
							@click="dialdelplan(rowPlanSelection[0].C_UI)"
						>
						  Supprimer le plan
						</b-button>
						<br>
						<hr>
						<b-form-file
							v-model="file1"
							accept=".svgz"
							:state="Boolean(file1)"
							placeholder="Choisissez un fichier ou déposez-le ici.."
							drop-placeholder="Déposez le fichier ici..."
						></b-form-file>
						<div class="mt-3" v-if="file1">Plan : {{rowPlanSelection[0].C_UI}}</div>
						<button class="btn btn-success" v-if="file1" @click="upload(rowPlanSelection[0].C_UI)">
						  Upload
						</button>
						<div v-if="file1" class="progress">
							<div
							class="progress-bar progress-bar-info progress-bar-striped"
							role="progressbar"
							:aria-valuenow="progress"
							aria-valuemin="0"
							aria-valuemax="100"
							:style="{ width: progress + '%' }"
							>
							{{ progress }}%
							</div>
						</div>
					</div>
				</div>
				<template
				slot="table-row"
				slot-scope="props"
				>
				<span
				  v-if="props.column.field === 'C_libelle'"
				  class="text-nowrap"
				>
					<span v-if="props.row.B_plan === 0"> 
						{{ props.row.C_libelle }} (Fichier inexistant)
					</span>
					<span v-else>
					  {{ props.row.C_libelle }} 
					</span>
				</span>
				<span v-else>
				  {{ props.formattedRow[props.column.field] }}
				</span>
				</template>
			</vue-good-table>
			</b-card-body>
		  </b-card>
      </b-col>
    </b-row>
  </section>
</template>
<script>
import { BRow, BCol, BAvatar, BCard, BImg, BCardBody, BCardText, BCardTitle, BMedia, BMediaAside, BAvatarGroup, VBTooltip, BMediaBody, BFormRadio, BFormInput, BFormGroup, BButton, BFormCheckbox, BFormFile, BModal, BFormSelect, BBadge, BSpinner } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import HomeMedal from './HomeMedal.vue'
	
export default {
	components: {
		BRow,
		BCol,
		BAvatar,
		VueGoodTable,
		BCard, 
		BImg, 
		BCardBody, 
		BCardText, 
		BCardTitle, 
		BMedia, 
		BMediaAside, 
		BAvatarGroup, 
		BMediaBody,
		BFormRadio,
		BFormInput,
		BFormGroup,
		BButton,
		BFormCheckbox,
		BFormFile,
		BFormSelect,
		BModal,
		BBadge,
		BSpinner,
		HomeMedal,
	},
	directives: {
		Ripple,
		'b-tooltip': VBTooltip,
	},
	data() {
		return {
			resultSoc: [],
			resultSite: [],
			idsite: '',
			columns: [
				{
					label: 'Libelle',
					field: 'C_libelle',
				},
				{
				  label: 'Société',
				  field: 'C_rs',
				},
				{
				  label: 'En prod',
				  field: 'B_compteprod',
				},
				{
				  label: 'National Box',
				  field: 'C_nationalbox',
				},
				{
				  label: 'Exp. compta',
				  field: 'B_compta',
				},
				{
				  label: 'Signature',
				  field: 'B_signature',
				},
				{
				  label: 'Nb sign.',
				  field: 'I_nbmois',
				},
			],
			chatwoot: {
				loading: false,
				busy: false,
				configured: false,
				inbox_id: '',
				base_url: 'https://chat.buxida.com',
			},
			wpSubsite: {
				loading: false,
				busy: false,
				configured: false,
				slug: '',
				slugInput: '',
				slugAvailable: null,
				slugCheckBusy: false,
				adminEmailInput: '',
				url: '',
				adminEmail: '',
				status: '',
				blogId: 0,
				createdAt: null,
				publishRequestedAt: null,
				publishRequestNote: '',
				publishedAt: null,
				reviewNote: '',
				reviewNoteAt: null,
				reviewNoteInput: '',
			},
			sms: {
				loading: false,
				busy: false,
				configured: false,
				libelle: '',
				maxmois: 0,
				nbuse: 0,
				nbrest: 0,
			},
			rows: [],
			selctrow: [],
			columnsplan: [
				{
					label: 'Libelle',
					field: 'C_libelle',
				},
				{
					label: 'Site',
					field: 'C_site',
				},
				{
				  label: 'Ordre',
				  field: 'I_ordre',
				},
			],
			rowsplan: [],
			rowPlanSelection: [],
			columnslog: [
				{
					label: 'Date',
					field: 'C_date',
				},
				{
					label: 'IP',
					field: 'C_ip',
				},
				{
				  label: 'Pays',
				  field: 'C_country',
				},
				{
				  label: 'Etat',
				  field: 'C_type',
				},
				{
				  label: 'Email',
				  field: 'C_email',
				},
				{
				  label: 'Société',
				  field: 'C_rs',
				},
				{
				  label: 'Utilisateur',
				  field: 'C_utilisateur',
				},
			],
			rowsite: [],
			columnsite: [
				{
					label: 'Libelle',
					field: 'C_libelle',
				},
			],
			rowslog: [],
			mediaData: [],
			avatars: [],
			bsignatureactive: 0,
			bsignatureprod: 0,
			bsignaturmarquage: 0,
			nbsign: 0,
			bcentreenprod: 0,
			bemplacement: 0,
			bbox: 0,
			bplan: 0,
			bmodelecontrat: 0,
			bnationalbox: 0,
			CUI: '',
			libplan: '',
			libsite: '',
			file1: null,
			progress: 0,
			CUIPLAN: '',
		}
	},
	created() {
		this.$http.get('/admin/lstcompte')
		.then(response => {
			if (response.status === 200) {
				this.ResultSoc = response.data.ResultSoc
			} else {
				this.$router.push('/login')	
			}
		})
		this.$http.get('/admin/lstsoc')
		.then(response => { this.rows = response.data.ResultSoc })
	},	  
	methods: {
		onRowClick(params) {
			this.CUI = params.row.C_UI
			this.selctrow = { C_libelle: params.row.C_libelle, C_adresse: `${params.row.C_adresse} ${params.row.C_cp} ${params.row.C_ville}`, C_tel: params.row.C_tel, C_logo: params.row.C_logo }
			this.mediaData = [
				{ avatar: 'UserIcon', title: 'Contact', subtitle: `${params.row.C_prenom}  ${params.row.C_nom}` },
				{ avatar: 'PhoneCallIcon', title: 'Téléphone', subtitle: params.row.C_tel },
				{ avatar: 'MailIcon', title: 'E-mail', subtitle: params.row.C_email },
			]
			this.nbsign = 0
			this.bsignatureactive = 0
			this.bsignatureprod = 0
			this.bsignaturmarquage = 0
			
			let LBbiometrichash = ''
			if (params.row.bcentreenprod === 1) {
				this.bcentreenprod = 1
			} else {
				this.bcentreenprod = 0
			}
			if (params.row.bemplacement === 1) {
				this.bemplacement = 1
			} else {
				this.bemplacement = 0
			}
			if (params.row.bbox === 1) {
				this.bbox = 1
			} else {
				this.bbox = 0
			}
			if (params.row.bplan === 1) {
				this.bplan = 1
			} else {
				this.bplan = 0
			}
			if (params.row.bmodelecontrat === 1) {
				this.bmodelecontrat = 1
			} else {
				this.bmodelecontrat = 0
			}
			if (params.row.B_nationalbox === 1) {
				this.bnationalbox = 1
			} else {
				this.bnationalbox = 0
			}
			if (params.row.B_signatureactive === 1) {
				this.bsignatureactive = 1
				this.nbsign = params.row.I_nbmois
				if (params.row.B_biometric_hash === 1) {
					this.bsignaturmarquage = 1
					LBbiometrichash = 'Bande de signature activée'	
				} else {
					this.bsignaturmarquage = 0
					LBbiometrichash = 'Bande de signature désactivée'	
				}
				if (params.row.B_prod === 1) {
					this.bsignatureprod = 1
					this.mediaData.push({
						avatar: 'CheckCircleIcon',
						title: 'Signature',
						subtitle: `En production : ${params.row.I_nbmois} signatures par mois ${LBbiometrichash}`,
					})	
				} else {
					this.bsignatureprod = 0
					this.mediaData.push({
						avatar: 'CheckCircleIcon',
						title: 'Signature',
						subtitle: `En test : ${params.row.I_nbmois} signatures par mois ${LBbiometrichash}`,
					})	
				}
			}
			this.$http.get(`/admin/lstplan/${this.CUI}`)
			.then(response => { this.rowsplan = response.data.Rplan })
			this.$http.get(`/admin/lstsite/${this.CUI}`)
			.then(response => { this.rowsite = response.data.Rsite })
			this.$http.get(`/admin/lstsite/${this.CUI}`)
			.then(response => { this.resultSite = response.data.Rsite })
			this.loadChatwootStatus()
			this.loadWpSubsiteStatus()
			this.loadSmsStatus()
		},
		resetChatwootState() {
			this.chatwoot.loading = false
			this.chatwoot.busy = false
			this.chatwoot.configured = false
			this.chatwoot.inbox_id = ''
		},
		loadChatwootStatus() {
			if (!this.CUI) { this.resetChatwootState(); return }
			this.chatwoot.loading = true
			this.$http.get(`/admin/chatwoot/status?CUIS=${encodeURIComponent(this.CUI)}`)
				.then(response => {
					this.chatwoot.loading = false
					if (response.data && response.data.res === 1) {
						this.chatwoot.configured = !!response.data.configured
						this.chatwoot.inbox_id = response.data.inbox_id || ''
						if (response.data.base_url) { this.chatwoot.base_url = response.data.base_url }
					} else {
						this.resetChatwootState()
					this.resetWpSubsiteState()
					}
				})
				.catch(() => { this.resetChatwootState() })
		},
		provisionChatwoot() {
			if (!this.CUI || this.chatwoot.busy) { return }
			this.chatwoot.busy = true
			this.$http.post('/admin/chatwoot/provision', { CUIS: this.CUI })
				.then(response => {
					this.chatwoot.busy = false
					if (response.data && response.data.res === 1) {
						this.chatwoot.configured = true
						this.chatwoot.inbox_id = response.data.inbox_id || ''
						this.$toast({
							component: ToastificationContent,
							props: {
								title: response.data.already ? 'Déjà activé' : 'Chat support clients finaux activé 🎉',
								icon: 'CheckIcon',
								variant: 'success',
								text: response.data.already
									? 'Ce centre avait déjà une inbox Chatwoot.'
									: 'Account + inbox + identity validation OK.',
							},
						}, { timeout: 6000, position: 'top-center' })
					} else {
						const detail = (response.data && response.data.detail) || 'Erreur inconnue'
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'Provisioning impossible',
								icon: 'AlertTriangleIcon',
								variant: 'danger',
								text: detail,
							},
						}, { timeout: 8000, position: 'top-center' })
					}
				})
				.catch(err => {
					this.chatwoot.busy = false
					const detail = (err && err.response && err.response.data && err.response.data.detail) || (err && err.message) || 'Erreur réseau'
					this.$toast({
						component: ToastificationContent,
						props: {
							title: 'Provisioning impossible',
							icon: 'AlertTriangleIcon',
							variant: 'danger',
							text: detail,
						},
					}, { timeout: 8000, position: 'top-center' })
				})
		},
		applyDefaultFeatures() {
			if (!this.CUI || this.chatwoot.busy) { return }
			this.chatwoot.busy = true
			this.$http.post('/admin/chatwoot/apply-default-features', { CUIS: this.CUI })
				.then(response => {
					this.chatwoot.busy = false
					const data = response.data || {}
					if (data.res === 1 && data.ok) {
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'Features par défaut appliquées',
								icon: 'CheckIcon',
								variant: 'success',
								text: 'Captain, Audit, SLA, Custom roles, Help Center, Automations désactivés pour ce centre.',
							},
						}, { timeout: 6000, position: 'top-center' })
					} else if (data.res === 1 && !data.ok) {
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'API Chatwoot a refusé le payload',
								icon: 'AlertTriangleIcon',
								variant: 'warning',
								text: 'À désactiver manuellement dans super_admin/accounts. Détail console.',
							},
						}, { timeout: 8000, position: 'top-center' })
						// console.warn('apply-default-features errors:', data.errors)
					} else {
						const detail = (data && data.hint) || 'Erreur inconnue'
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'Action impossible',
								icon: 'AlertTriangleIcon',
								variant: 'danger',
								text: detail,
							},
						}, { timeout: 8000, position: 'top-center' })
					}
				})
				.catch(err => {
					this.chatwoot.busy = false
					const detail = (err && err.response && err.response.data && err.response.data.hint) || (err && err.message) || 'Erreur réseau'
					this.$toast({
						component: ToastificationContent,
						props: {
							title: 'Erreur',
							icon: 'AlertTriangleIcon',
							variant: 'danger',
							text: detail,
						},
					}, { timeout: 6000, position: 'top-center' })
				})
		},
		deprovisionChatwoot() {
			if (!this.CUI || this.chatwoot.busy) { return }
			if (!window.confirm('Désactiver le chat support des clients finaux pour ce centre ? L\'inbox côté Chatwoot ne sera pas supprimée (à archiver manuellement si besoin).')) { return }
			this.chatwoot.busy = true
			this.$http.post('/admin/chatwoot/deprovision', { CUIS: this.CUI })
				.then(response => {
					this.chatwoot.busy = false
					if (response.data && response.data.res === 1) {
						this.chatwoot.configured = false
						this.chatwoot.inbox_id = ''
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'Chat support clients finaux désactivé',
								icon: 'CheckIcon',
								variant: 'success',
								text: 'Les colonnes BUXIDA ont été vidées.',
							},
						}, { timeout: 4000, position: 'top-center' })
					} else {
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'Erreur',
								icon: 'AlertTriangleIcon',
								variant: 'danger',
								text: 'Impossible de désactiver',
							},
						}, { timeout: 4000, position: 'top-center' })
					}
				})
				.catch(() => {
					this.chatwoot.busy = false
					this.$toast({
						component: ToastificationContent,
						props: {
							title: 'Erreur réseau',
							icon: 'AlertTriangleIcon',
							variant: 'danger',
							text: 'Impossible de joindre le serveur',
						},
					}, { timeout: 4000, position: 'top-center' })
				})
		},
		// ===== WP Multisite (Phase 1) =====
		resetWpSubsiteState() {
			this.wpSubsite.loading = false
			this.wpSubsite.busy = false
			this.wpSubsite.configured = false
			this.wpSubsite.slug = ''
			this.wpSubsite.slugInput = ''
			this.wpSubsite.slugAvailable = null
			this.wpSubsite.slugCheckBusy = false
			this.wpSubsite.adminEmailInput = ''
			this.wpSubsite.url = ''
			this.wpSubsite.adminEmail = ''
			this.wpSubsite.status = ''
			this.wpSubsite.blogId = 0
			this.wpSubsite.createdAt = null
			this.wpSubsite.publishRequestedAt = null
			this.wpSubsite.publishRequestNote = ''
			this.wpSubsite.publishedAt = null
			this.wpSubsite.reviewNote = ''
			this.wpSubsite.reviewNoteAt = null
			this.wpSubsite.reviewNoteInput = ''
		},
		loadWpSubsiteStatus() {
			if (!this.CUI) { this.resetWpSubsiteState(); return }
			this.wpSubsite.loading = true
			this.$http.get(`/admin/wp-multisite/status?CUIS=${encodeURIComponent(this.CUI)}`)
				.then(response => {
					this.wpSubsite.loading = false
					const d = response.data || {}
					if (d.res === 1 && d.configured) {
						this.wpSubsite.configured = true
						this.wpSubsite.slug = d.slug || ''
						this.wpSubsite.url = d.url || ''
						this.wpSubsite.adminEmail = d.admin_email || ''
						this.wpSubsite.status = d.status || ''
						this.wpSubsite.blogId = d.blog_id || 0
						this.wpSubsite.createdAt = d.created_at
						this.wpSubsite.publishRequestedAt = d.publish_requested_at
						this.wpSubsite.publishRequestNote = d.publish_request_note || ''
						this.wpSubsite.publishedAt = d.published_at
						this.wpSubsite.reviewNote = d.review_note || ''
						this.wpSubsite.reviewNoteAt = d.review_note_at
					} else {
						this.wpSubsite.configured = false
					}
				})
				.catch(() => { this.resetWpSubsiteState() })
		},
		checkWpSlug() {
			const s = (this.wpSubsite.slugInput || '').toLowerCase().trim()
			if (!s) { this.wpSubsite.slugAvailable = null; return }
			this.wpSubsite.slugCheckBusy = true
			this.$http.get(`/admin/wp-multisite/check-slug?slug=${encodeURIComponent(s)}`)
				.then(response => {
					this.wpSubsite.slugCheckBusy = false
					this.wpSubsite.slugAvailable = !!(response.data && response.data.available)
				})
				.catch(() => {
					this.wpSubsite.slugCheckBusy = false
					this.wpSubsite.slugAvailable = null
				})
		},
		provisionWpSubsite() {
			if (!this.CUI || this.wpSubsite.busy) { return }
			const slug = (this.wpSubsite.slugInput || '').toLowerCase().trim()
			const adminEmail = (this.wpSubsite.adminEmailInput || '').trim()
			if (!slug) {
				this.$toast({ component: ToastificationContent, props: { title: 'Slug requis', icon: 'AlertTriangleIcon', variant: 'warning', text: 'Saisissez un slug avant de creer.' } }, { timeout: 4000, position: 'top-center' })
				return
			}
			if (!window.confirm(`Creer le site web pour ce centre ?\n\nURL future : https://${slug}.self-stockage.solutions/\nAdmin : ${adminEmail || '(email du centre par defaut)'}\n\nLe site sera cree en mode "Coming Soon" et un email sera envoye au gestionnaire.`)) { return }
			this.wpSubsite.busy = true
			this.$http.post('/admin/wp-multisite/provision', { CUIS: this.CUI, slug: slug, adminEmail: adminEmail })
				.then(response => {
					this.wpSubsite.busy = false
					const d = response.data || {}
					if (d.res === 1) {
						this.$toast({ component: ToastificationContent, props: { title: d.already ? 'Deja provisionne' : 'Site web cree 🎉', icon: 'CheckIcon', variant: 'success', text: d.already ? 'Ce centre avait deja un subsite.' : `URL : ${d.url} (mode Coming Soon)` } }, { timeout: 6000, position: 'top-center' })
						this.loadWpSubsiteStatus()
					} else {
						const detail = d.detail || d.error || 'Erreur inconnue'
						this.$toast({ component: ToastificationContent, props: { title: 'Provisioning impossible', icon: 'AlertTriangleIcon', variant: 'danger', text: detail } }, { timeout: 8000, position: 'top-center' })
					}
				})
				.catch(err => {
					this.wpSubsite.busy = false
					const detail = (err && err.response && err.response.data && (err.response.data.detail || err.response.data.error)) || (err && err.message) || 'Erreur reseau'
					this.$toast({ component: ToastificationContent, props: { title: 'Provisioning impossible', icon: 'AlertTriangleIcon', variant: 'danger', text: detail } }, { timeout: 8000, position: 'top-center' })
				})
		},
		publishWpSubsite() {
			if (!this.CUI || this.wpSubsite.busy) { return }
			if (!window.confirm('Mettre ce site en ligne publiquement ?\n\nIl deviendra visible et indexable par Google.')) { return }
			this.wpSubsite.busy = true
			this.$http.post('/admin/wp-multisite/publish', { CUIS: this.CUI })
				.then(response => {
					this.wpSubsite.busy = false
					if (response.data && response.data.res === 1) {
						this.$toast({ component: ToastificationContent, props: { title: 'Site mis en ligne ✅', icon: 'CheckIcon', variant: 'success', text: response.data.url } }, { timeout: 5000, position: 'top-center' })
						this.loadWpSubsiteStatus()
					} else {
						const detail = (response.data && response.data.detail) || 'Erreur inconnue'
						this.$toast({ component: ToastificationContent, props: { title: 'Publication impossible', icon: 'AlertTriangleIcon', variant: 'danger', text: detail } }, { timeout: 8000, position: 'top-center' })
					}
				})
				.catch(err => {
					this.wpSubsite.busy = false
					const detail = (err && err.response && err.response.data && err.response.data.detail) || (err && err.message) || 'Erreur reseau'
					this.$toast({ component: ToastificationContent, props: { title: 'Publication impossible', icon: 'AlertTriangleIcon', variant: 'danger', text: detail } }, { timeout: 8000, position: 'top-center' })
				})
		},
		requestChangesWpSubsite() {
			if (!this.CUI || this.wpSubsite.busy) { return }
			const note = (this.wpSubsite.reviewNoteInput || '').trim()
			if (!note || note.length < 5) {
				this.$toast({ component: ToastificationContent, props: { title: 'Note requise', icon: 'AlertTriangleIcon', variant: 'warning', text: 'Indiquez au gestionnaire ce qui doit etre corrige (5 caracteres min).' } }, { timeout: 5000, position: 'top-center' })
				return
			}
			this.wpSubsite.busy = true
			this.$http.post('/admin/wp-multisite/request-changes', { CUIS: this.CUI, reviewNote: note })
				.then(response => {
					this.wpSubsite.busy = false
					if (response.data && response.data.res === 1) {
						this.$toast({ component: ToastificationContent, props: { title: 'Demande de corrections envoyee', icon: 'CheckIcon', variant: 'success', text: 'Le subsite repasse en mode Coming Soon avec votre note.' } }, { timeout: 5000, position: 'top-center' })
						this.wpSubsite.reviewNoteInput = ''
						this.loadWpSubsiteStatus()
					} else {
						this.$toast({ component: ToastificationContent, props: { title: 'Erreur', icon: 'AlertTriangleIcon', variant: 'danger', text: 'Impossible de demander les corrections' } }, { timeout: 5000, position: 'top-center' })
					}
				})
				.catch(() => {
					this.wpSubsite.busy = false
					this.$toast({ component: ToastificationContent, props: { title: 'Erreur reseau', icon: 'AlertTriangleIcon', variant: 'danger', text: 'Impossible de joindre le serveur' } }, { timeout: 5000, position: 'top-center' })
				})
		},
		// ===== Paramètres SMS =====
		resetSmsState() {
			this.sms.loading = false
			this.sms.busy = false
			this.sms.configured = false
			this.sms.libelle = ''
			this.sms.maxmois = 0
			this.sms.nbuse = 0
			this.sms.nbrest = 0
		},
		loadSmsStatus() {
			if (!this.CUI) { this.resetSmsState(); return }
			this.sms.loading = true
			this.$http.get(`/admin/sms/status?CUIS=${encodeURIComponent(this.CUI)}`)
				.then(response => {
					this.sms.loading = false
					const d = response.data || {}
					if (d.res === 1) {
						this.sms.configured = !!d.configured
						this.sms.libelle = d.C_libelle || ''
						this.sms.maxmois = d.I_maxmois || 0
						this.sms.nbuse = d.I_nbuse || 0
						this.sms.nbrest = d.I_nbrest || 0
					} else {
						this.resetSmsState()
					}
				})
				.catch(() => { this.resetSmsState() })
		},
		saveSmsParams() {
			if (!this.CUI || this.sms.busy) { return }
			const lib = (this.sms.libelle || '').trim()
			if (lib && !/^[A-Za-z0-9 ]{1,11}$/.test(lib)) {
				this.$toast({ component: ToastificationContent, props: { title: 'Sender invalide', icon: 'AlertTriangleIcon', variant: 'warning', text: 'Alphanumérique, 11 caractères max.' } }, { timeout: 5000, position: 'top-center' })
				return
			}
			const max = parseInt(this.sms.maxmois, 10)
			if (!Number.isFinite(max) || max < 0) {
				this.$toast({ component: ToastificationContent, props: { title: 'Quota invalide', icon: 'AlertTriangleIcon', variant: 'warning', text: 'Entier ≥ 0.' } }, { timeout: 5000, position: 'top-center' })
				return
			}
			this.sms.busy = true
			this.$http.post('/admin/sms/save', { CUIS: this.CUI, I_maxmois: max, C_libelle: lib })
				.then(response => {
					this.sms.busy = false
					if (response.data && response.data.res === 1) {
						this.$toast({ component: ToastificationContent, props: { title: 'Paramètres SMS enregistrés 🎉', icon: 'CheckIcon', variant: 'success', text: '' } }, { timeout: 4000, position: 'top-center' })
						this.loadSmsStatus()
					} else {
						this.$toast({ component: ToastificationContent, props: { title: 'Erreur', icon: 'AlertTriangleIcon', variant: 'danger', text: 'Sauvegarde impossible' } }, { timeout: 4000, position: 'top-center' })
					}
				})
				.catch(() => {
					this.sms.busy = false
					this.$toast({ component: ToastificationContent, props: { title: 'Erreur réseau', icon: 'AlertTriangleIcon', variant: 'danger', text: '' } }, { timeout: 4000, position: 'top-center' })
				})
		},
		majsign() {
			this.$http.post('/admin/majsign', { CUIS: this.CUI, bsign: this.bsignatureactive, bprod: this.bsignatureprod, nbsign: this.nbsign, bmarquage: this.bsignaturmarquage })
			.then(response => {
				if (response.data.res === 1) {
					this.rows = []
					this.mediaData = []
					this.selctrow = []
					this.CUI = ''
					this.resetChatwootState()
					this.resetWpSubsiteState()
					this.resetSmsState()
					this.nbsign = 0
					this.bsignatureactive = 0
					this.bsignaturmarquage = 0
					this.bsignatureprod = 0
					this.bnationalbox = 0
					this.bcentreenprod = 0
					this.bemplacement = 0
					this.bbox = 0
					this.bplan = 0
					this.bmodelecontrat = 0
					this.LBbiometrichash = ''
					this.$http.get('/admin/lstsoc')
					.then(responselstsoc => { this.rows = responselstsoc.data.ResultSoc })
					this.$toast({
					component: ToastificationContent,
					position: 'top-right',
						props: {
						  title: 'Ok c\'est fait ! 🎉',
						  icon: 'CheckIcon',
						  variant: 'success',
						  text: 'Modifications enregistrées',
						},
					},
					{
					timeout: 8000,
					position: 'top-center',
					})
				} else {
					this.$toast({
						component: ToastificationContent,
						props: {
							title: 'Oups',
							icon: 'SmileIcon',
							variant: 'danger',
							text: 'Erreur : action impossible',
						},
					},
					{
						timeout: 4000,
						position: 'top-center',
					})
				}
			})	
		},
		majsparamsoc() {
			this.$http.post('/admin/majsparamsoc', { CUIS: this.CUI, bnationalbox: this.bnationalbox })
			.then(response => {
				if (response.data.res === 1) {
					this.rows = []
					this.mediaData = []
					this.selctrow = []
					this.CUI = ''
					this.resetChatwootState()
					this.resetWpSubsiteState()
					this.resetSmsState()
					this.nbsign = 0
					this.bsignatureactive = 0
					this.bsignaturmarquage = 0
					this.bsignatureprod = 0
					this.bnationalbox = 0
					this.bcentreenprod = 0
					this.bemplacement = 0
					this.bbox = 0
					this.bplan = 0
					this.bmodelecontrat = 0
					this.LBbiometrichash = ''
					this.$http.get('/admin/lstsoc')
					.then(responselstsoc => { this.rows = responselstsoc.data.ResultSoc })
					this.$toast({
					component: ToastificationContent,
					position: 'top-right',
						props: {
						  title: 'Ok c\'est fait ! 🎉',
						  icon: 'CheckIcon',
						  variant: 'success',
						  text: 'Modifications enregistrées',
						},
					},
					{
					timeout: 8000,
					position: 'top-center',
					})
				} else {
					this.$toast({
						component: ToastificationContent,
						props: {
							title: 'Oups',
							icon: 'SmileIcon',
							variant: 'danger',
							text: 'Erreur : action impossible',
						},
					},
					{
						timeout: 4000,
						position: 'top-center',
					})
				}
			})	
		},
		majinitsoc() {
			this.$http.post('/admin/majsparamsinit', { CUIS: this.CUI, bcentreenprod: this.bcentreenprod, bemplacement: this.bemplacement, bbox: this.bbox, bplan: this.bplan, bmodelecontrat: this.bmodelecontrat })
			.then(response => {
				if (response.data.res === 1) {
					this.rows = []
					this.mediaData = []
					this.selctrow = []
					this.CUI = ''
					this.resetChatwootState()
					this.resetWpSubsiteState()
					this.resetSmsState()
					this.nbsign = 0
					this.bsignatureactive = 0
					this.bsignaturmarquage = 0
					this.bsignatureprod = 0
					this.bnationalbox = 0
					this.bcentreenprod = 0
					this.bemplacement = 0
					this.bbox = 0
					this.bplan = 0
					this.bmodelecontrat = 0
					this.LBbiometrichash = ''
					this.$http.get('/admin/lstsoc')
					.then(responselstsoc => { this.rows = responselstsoc.data.ResultSoc })
					this.$toast({
					component: ToastificationContent,
					position: 'top-right',
						props: {
						  title: 'Ok c\'est fait ! 🎉',
						  icon: 'CheckIcon',
						  variant: 'success',
						  text: 'Modifications enregistrées',
						},
					},
					{
					timeout: 8000,
					position: 'top-center',
					})
				} else {
					this.$toast({
						component: ToastificationContent,
						props: {
							title: 'Oups',
							icon: 'SmileIcon',
							variant: 'danger',
							text: 'Erreur : action impossible',
						},
					},
					{
						timeout: 4000,
						position: 'top-center',
					})
				}
			})	
		},
		addplan() {
			if ((this.libplan !== '') && (this.idsite !== '')) {
				this.$http.post('/admin/addplan', { CUIS: this.CUI, libplan: this.libplan, cuisite: this.idsite })
				.then(response => {
					if (response.data.res === 1) {
						this.libplan = ''
						this.idsite = ''
						this.$http.get(`/admin/lstplan/${this.CUI}`)
						.then(responselstplan => { this.rowsplan = responselstplan.data.Rplan })
						this.$toast({
						component: ToastificationContent,
						position: 'top-right',
							props: {
							  title: 'Ok c\'est fait ! 🎉',
							  icon: 'CheckIcon',
							  variant: 'success',
							  text: 'Modifications enregistrées',
							},
						},
						{
						timeout: 8000,
						position: 'top-center',
						})
					} else {
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'Oups',
								icon: 'SmileIcon',
								variant: 'danger',
								text: 'Erreur : action impossible',
							},
						},
						{
							timeout: 4000,
							position: 'top-center',
						})
					}
				})	
			} else {
				this.$toast({
					component: ToastificationContent,
					props: {
						title: 'Oups',
						icon: 'SmileIcon',
						variant: 'danger',
						text: 'Erreur : Merci de choisir un site et saisir un libellé',
					},
				},
				{
					timeout: 4000,
					position: 'top-center',
				})
			}
		},
		addsite() {
			if (this.libsite !== '') {
				this.$http.post('/admin/addsite', { CUIS: this.CUI, libsite: this.libsite })
				.then(response => {
					if (response.data.res === 1) {
						this.libsite = ''
						this.$http.get(`/admin/lstsite/${this.CUI}`)
						.then(responseaddsite => { this.rowsite = responseaddsite.data.Rsite })
						this.$toast({
						component: ToastificationContent,
						position: 'top-right',
							props: {
							  title: 'Ok c\'est fait ! 🎉',
							  icon: 'CheckIcon',
							  variant: 'success',
							  text: 'Modifications enregistrées',
							},
						},
						{
						timeout: 8000,
						position: 'top-center',
						})
					} else {
						this.$toast({
							component: ToastificationContent,
							props: {
								title: 'Oups',
								icon: 'SmileIcon',
								variant: 'danger',
								text: 'Erreur : action impossible',
							},
						},
						{
							timeout: 4000,
							position: 'top-center',
						})
					}
				})	
			} else {
				this.$toast({
					component: ToastificationContent,
					props: {
						title: 'Oups',
						icon: 'SmileIcon',
						variant: 'danger',
						text: 'Erreur : Merci de saisir un libellé',
					},
				},
				{
					timeout: 4000,
					position: 'top-center',
				})
			}
		},
		selectionPlanChanged(params) {
			this.rowPlanSelection = params.selectedRows
		},
		voirplan: function (ui) {   
		  window.open(`https://ubicx.blob.core.windows.net/bbc/plans/${ui}.svgz`, '_blank')
		},
		upload(CUIP) {
			const formData = new FormData()
			formData.append('CUIP', CUIP)
			formData.append('file', this.file1)
			const headers = { 'Content-Type': 'multipart/form-data' }
			this.$http.post('/admin/uploadplan', formData, { headers })
			.then(response => {
				if (response.data.res === 1) {
					this.libplan = ''
					this.file1 = null
					this.$http.get(`/admin/lstplan/${this.CUI}`)
					.then(responselstplan => { this.rowsplan = responselstplan.data.Rplan })
					this.$toast({
					component: ToastificationContent,
					position: 'top-right',
						props: {
						  title: 'Ok c\'est fait ! 🎉',
						  icon: 'CheckIcon',
						  variant: 'success',
						  text: 'Modifications enregistrées',
						},
					},
					{
					timeout: 8000,
					position: 'top-center',
					})
				} else {
					this.$toast({
						component: ToastificationContent,
						props: {
							title: 'Oups',
							icon: 'SmileIcon',
							variant: 'danger',
							text: 'Erreur : action impossible',
						},
					},
					{
						timeout: 4000,
						position: 'top-center',
					})
				}
			})	
		},
		dialdelplan(CUIP) {
			this.CUIPLAN = CUIP
			this.$bvModal.show('affsuppplan')
		},
		delplan() {
			this.$http.post('/admin/delplan', { CUIP: this.CUIPLAN })
			.then(response => {
				if (response.data.res === 1) {
					this.$bvModal.hide('affsuppplan')
					this.libplan = ''
					this.CUIPLAN = ''
					this.$http.get(`/admin/lstplan/${this.CUI}`)
					.then(responselstplan => { this.rowsplan = responselstplan.data.Rplan })
					this.$toast({
					component: ToastificationContent,
					position: 'top-right',
						props: {
						  title: 'Ok c\'est fait ! 🎉',
						  icon: 'CheckIcon',
						  variant: 'success',
						  text: 'Modifications enregistrées',
						},
					},
					{
					timeout: 8000,
					position: 'top-center',
					})
				} else {
					this.$toast({
						component: ToastificationContent,
						props: {
							title: 'Oups',
							icon: 'SmileIcon',
							variant: 'danger',
							text: 'Erreur : action impossible',
						},
					},
					{
						timeout: 4000,
						position: 'top-center',
					})
				}
			})	
		},
	},
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
